const locale = {
	DETAILS_THUMBNAIL_SECTION: 'Thumbnail image',
	DETAILS_THUMBNAIL_SUBHEADER: 'View and edit the thumbnail image',

	DETAILS_COMMUNICATIONS_HEADER_BUTTON_SEND_REMINDER: 'Send mail reminder',

	// #region Communications fields
	DETAILS_COMMUNICATIONS_FIELD_TITLE: 'Title',
	DETAILS_COMMUNICATIONS_FIELD_DATE_FROM: 'Publish date',
	DETAILS_COMMUNICATIONS_FIELD_DATE_TO: 'Due date',
	DETAILS_COMMUNICATIONS_FIELD_IMAGE: 'Image',
	DETAILS_COMMUNICATIONS_FIELD_ACTIVE: 'Active',
	DETAILS_COMMUNICATIONS_FIELD_READNOTIFICATION: 'Request read receipt',
	DETAILS_COMMUNICATIONS_FIELD_TAGS: 'Tags',
	DETAILS_COMMUNICATIONS_FIELD_WARNING: 'Warning',
	DETAILS_COMMUNICATIONS_FIELD_BLOCKED: 'Blocked',
	// #endregion

	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_COMMUNICATION: 'Communication',
	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_USER: 'User',
	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_READ: 'Read receipt',
	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_DATE: 'Read date',

	DETAILS_HEADER_BUTTON_COMMUNICATIONS_DOCUMENTS_SETTINGS: 'Docs configuration',

	// #region Communication misc fields (dialog, cards)
	TAB_ATTACHMENTS: 'Attachments',
	TAB_READ_RECEIPTS: 'Read receipts',
	TAB_READ_RECEIPTS_ALERT_TITLE: 'Read receipts disabled',
	TAB_READ_RECEIPTS_ALERT_DESCRIPTION:
		'To track read receipts, enable the "Request read receipt" option in the details.',

	COMMUNICATIONS_REMINDER_DIALOG_TITLE_CONFIRM: 'Are you sure to send a reminder?',

	DIALOG_READ_RECEIPTS_TITLE: 'Read receipts',
	DIALOG_READ_NOTIFICATION_MESSAGE_CONTENT:
		'Is required to send the read receipt for the communication "{coms_title}". Are you sure to you\'re done?',
	DIALOG_COMMUNICATION_CONTACT_TEXT: 'CONTACT',
	COMMUNICATION_CARD_OPEN: 'OPEN'
	// #endregion
};

export default locale;
